import { render } from "./VposHome.vue?vue&type=template&id=47558e4e"
import script from "./VposHome.vue?vue&type=script&lang=js"
export * from "./VposHome.vue?vue&type=script&lang=js"

import "./VposHome.vue?vue&type=style&index=0&id=47558e4e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__